import { CubeConnectionPoolConfig } from './cube-connection-pool';

export interface CubeAdapterConfig {
  endpoint: string;
  debug?: boolean;
  poolConfig?: CubeConnectionPoolConfig;
  sentry?: {
    dsn: string;
    environment: string;
    tracesSampleRate: number;
  };
}

export const DEFAULT_POOL_CONFIG: CubeConnectionPoolConfig = {
  maxConnections: 10,
  idleTimeout: 300000, // 5 minutes
  connectionTimeout: 30000, // 30 seconds
  retryAttempts: 3,
  retryDelay: 1000, // 1 second
};

export const PRODUCTION_POOL_CONFIG: CubeConnectionPoolConfig = {
  maxConnections: 20,
  idleTimeout: 600000, // 10 minutes
  connectionTimeout: 60000, // 60 seconds
  retryAttempts: 5,
  retryDelay: 2000, // 2 seconds
};

export const DEVELOPMENT_POOL_CONFIG: CubeConnectionPoolConfig = {
  maxConnections: 5,
  idleTimeout: 120000, // 2 minutes
  connectionTimeout: 15000, // 15 seconds
  retryAttempts: 2,
  retryDelay: 500, // 0.5 seconds
};
